(function () {
  var sectionSelector = '[data-sp-product-description]';
  var copySelector = '[data-sp-product-description-copy]';
  var mediaSelector = '[data-sp-product-description-media]';
  var enhancedClass = 'sp-product-description--enhanced';
  var hasMediaClass = 'sp-product-description__layout--has-media';
  var mosaicClass = 'sp-product-description__mosaic';
  var mosaicRowClass = 'sp-product-description__mosaic-row';
  var mosaicCellClass = 'sp-product-description__mosaic-cell';
  var mosaicTextClass = 'sp-product-description__mosaic-text';
  var mediaItemClass = 'sp-product-description__media-item';

  function hasMeaningfulText(element) {
    return element.textContent.replace(/\s+/g, '').length > 0;
  }

  function hasUsableMediaSource(media) {
    return ['src', 'srcset', 'data-src', 'data-srcset', 'poster'].some(function (attribute) {
      return (media.getAttribute(attribute) || '').trim() !== '';
    });
  }

  function hasUsableMedia(element) {
    var mediaNodes = [];

    if (element.matches('img, video, iframe')) {
      mediaNodes.push(element);
    }

    mediaNodes = mediaNodes.concat(Array.prototype.slice.call(element.querySelectorAll('img, video, iframe')));

    return mediaNodes.some(hasUsableMediaSource);
  }

  function removeEmptyMedia(element) {
    element.querySelectorAll('img, video, iframe').forEach(function (media) {
      if (!hasUsableMediaSource(media)) {
        media.remove();
      }
    });
  }

  // Inline / structural wrappers that importers routinely wrap a bare image in
  // (e.g. <p><b><img></b></p> or <p><span><img></span></p>). We recurse into
  // these instead of only checking one level deep, so a wrapped image is still
  // recognised as image-only rather than being misread as a text block.
  var imageOnlyWrapperTags = {
    a: true,
    b: true,
    strong: true,
    em: true,
    i: true,
    u: true,
    span: true,
    font: true,
    small: true,
    mark: true,
    div: true,
    figure: true,
    figcaption: true,
  };

  function isImageOnlyChildNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent.trim() === '';
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return true;
    }

    var tagName = node.tagName.toLowerCase();

    // Treat inert/invisible tags (e.g. the stray <meta charset> that some
    // product importers inject next to images) as ignorable.
    if (tagName === 'meta' || tagName === 'style' || tagName === 'script' || tagName === 'link' || tagName === 'wbr') {
      return true;
    }

    if (tagName === 'img' || tagName === 'picture' || tagName === 'source' || tagName === 'br') {
      return true;
    }

    if (imageOnlyWrapperTags[tagName]) {
      return Array.prototype.every.call(node.childNodes, isImageOnlyChildNode);
    }

    return false;
  }

  function isImageOnlyNode(element) {
    if (!element || !element.querySelector || (!element.matches('img') && !element.querySelector('img'))) {
      return false;
    }

    if (!hasUsableMedia(element)) {
      return false;
    }

    if (hasMeaningfulText(element)) {
      return false;
    }

    return Array.prototype.every.call(element.childNodes, isImageOnlyChildNode);
  }

  function removeEmptyTextBlocks(body) {
    Array.prototype.slice.call(body.children).forEach(function (element) {
      if (element.querySelector('img, video, iframe') && !hasUsableMedia(element) && !hasMeaningfulText(element)) {
        element.remove();
        return;
      }

      if (element.querySelector('img, video, iframe, table, ul, ol')) {
        return;
      }

      if (element.textContent.replace(/\s+/g, '').length === 0) {
        element.remove();
      }
    });
  }

  function removeDuplicateIds(element) {
    if (element.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    element.removeAttribute('id');
    element.querySelectorAll('[id]').forEach(function (child) {
      child.removeAttribute('id');
    });
  }

  function isMeaningfulDetailBlock(element) {
    if (isImageOnlyNode(element)) {
      return true;
    }

    if (element.querySelector('img, video, iframe') && !hasUsableMedia(element) && !hasMeaningfulText(element)) {
      return false;
    }

    if (element.querySelector('img, video, iframe')) {
      return hasUsableMedia(element);
    }

    if (element.querySelector('table, ul, ol')) {
      return true;
    }

    return hasMeaningfulText(element);
  }

  function pushTextBlock(blocks, elements) {
    if (elements.length === 0) {
      return;
    }

    blocks.push({
      type: 'text',
      elements: elements.slice(),
    });

    elements.length = 0;
  }

  function getDetailBlocks(body) {
    var blocks = [];
    var textElements = [];

    Array.prototype.slice.call(body.children).forEach(function (element) {
      if (!isMeaningfulDetailBlock(element)) {
        return;
      }

      if (isImageOnlyNode(element)) {
        pushTextBlock(blocks, textElements);
        blocks.push({
          type: 'media',
          elements: [element],
        });
        return;
      }

      textElements.push(element);
    });

    pushTextBlock(blocks, textElements);

    return blocks;
  }

  function cloneBlockElements(block) {
    return block.elements.map(function (element) {
      var clone = element.cloneNode(true);

      removeDuplicateIds(clone);
      removeEmptyMedia(clone);

      return clone;
    });
  }

  function createMosaicCell(block) {
    var cell = document.createElement(block.type === 'media' ? 'figure' : 'div');
    var clonedElements = cloneBlockElements(block);

    cell.className =
      mosaicCellClass +
      ' ' +
      mosaicCellClass +
      '--' +
      block.type +
      (block.type === 'media' ? ' ' + mediaItemClass : ' ' + mosaicTextClass + ' rte');

    clonedElements.forEach(function (element) {
      cell.appendChild(element);
    });

    return cell;
  }

  function getPairedRows(blocks) {
    var texts = [];
    var medias = [];

    blocks.forEach(function (block) {
      if (block.type === 'media') {
        medias.push(block);
      } else {
        texts.push(block);
      }
    });

    var rows = [];
    var pairCount = Math.min(texts.length, medias.length);
    var i;

    // Pair each text block with a media block so every row is a clean
    // text + image couple, regardless of the source ordering.
    for (i = 0; i < pairCount; i += 1) {
      rows.push([texts[i], medias[i]]);
    }

    // Any leftover blocks (unequal counts) render full-width on their own row.
    for (i = pairCount; i < texts.length; i += 1) {
      rows.push([texts[i]]);
    }

    for (i = pairCount; i < medias.length; i += 1) {
      rows.push([medias[i]]);
    }

    return rows;
  }

  function buildMosaic(body) {
    var blocks = getDetailBlocks(body);
    var hasMedia = blocks.some(function (block) {
      return block.type === 'media';
    });

    if (!hasMedia || blocks.length < 2) {
      return null;
    }

    var mosaic = document.createElement('div');
    var rows = getPairedRows(blocks);

    mosaic.className = mosaicClass;

    rows.forEach(function (rowBlocks, rowIndex) {
      var row = document.createElement('div');
      var orderedBlocks = rowBlocks.slice();

      row.className = mosaicRowClass;

      if (orderedBlocks.length === 1) {
        row.classList.add(mosaicRowClass + '--single');
      } else if (rowIndex % 2 === 1) {
        orderedBlocks.reverse();
      }

      orderedBlocks.forEach(function (block) {
        row.appendChild(createMosaicCell(block));
      });

      mosaic.appendChild(row);
    });

    return mosaic;
  }

  function enhanceSection(section) {
    if (section.classList.contains(enhancedClass)) {
      return;
    }

    var copy = section.querySelector(copySelector);
    var media = section.querySelector(mediaSelector);
    var layout = section.querySelector('.sp-product-description__layout');

    if (!copy || !media || !layout) {
      return;
    }

    section.classList.add(enhancedClass);
    media.hidden = true;
    layout.classList.remove(hasMediaClass);

    var body = copy.querySelector('.sp-product-description__body');

    if (!body) {
      return;
    }

    removeEmptyMedia(body);
    removeEmptyTextBlocks(body);

    var mosaic = buildMosaic(body);

    if (mosaic) {
      layout.appendChild(mosaic);
      layout.classList.add(hasMediaClass);
    }
  }

  function init() {
    document.querySelectorAll(sectionSelector).forEach(enhanceSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target &&
      (event.target.matches(sectionSelector) ? event.target : event.target.querySelector(sectionSelector));

    if (section) {
      enhanceSection(section);
    }
  });
})();
